import { __ } from "src/libs/utilities"
import { ITrack } from "../../data/interfaces"
import { Position, Tooltip } from "@blueprintjs/core"

/* Protopia Ecosystem component */
export interface ITrackVKLinkProps {
   item: ITrack
}
const TrackMaxLink = (props: ITrackVKLinkProps): JSX.Element => {
    const onClick = (evt:any) => {
        evt.stopPropagation()
    }
    return props.item.max_url 
        ?
        <a 
            className='pe-track-vk-link soc max position-absolute' style={{left: 55}} 
            href={props.item.max_url} 
            target="_blank" 
            rel="noreferrer" 
            onClick={onClick}
        >
            <div className="position-absolute" style={{ left:9, top:9 }}>
                <Tooltip position={Position.TOP} content={<div className="px-3 py-0">{__("Max")}</div>} >
                    <i style={{ backgroundSize: 18, filter: "invert(100%)" }}/>
                </Tooltip>
            </div>
        </a>
        :
        <></>
}
export default TrackMaxLink